
export default function BestPractices() {
  const practices = [
    {
      icon: 'ri-checkbox-circle-line',
      title: 'Be accurate and current',
      description: 'Inaccurate or overstated responses can lead to denied claims or rescinded coverage, as noted by Reed Smith LLP.',
      color: 'from-[#e10708] to-[#c00607]'
    },
    {
      icon: 'ri-file-text-line',
      title: 'Prepare supporting documentation',
      description: 'Have policies, network diagrams, backup reports, and incident response plans readily available.',
      color: 'from-[#c00607] to-[#a00506]'
    },
    {
      icon: 'ri-team-line',
      title: 'Involve IT and security leadership',
      description: 'Work with your IT manager, security team, or MSP to ensure technical accuracy, as recommended by CBTS.',
      color: 'from-[#a00506] to-[#e10708]'
    }
  ];

  return (
    <section className="py-20 px-6 bg-gradient-to-br from-gray-50 to-red-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Best Practices When Completing a Questionnaire
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#e10708] to-[#c00607] mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {practices.map((practice, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all border border-gray-200"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${practice.color} rounded-xl flex items-center justify-center mb-6`}>
                <i className={`${practice.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {practice.title}
              </h3>
              
              <p className="text-gray-700 leading-relaxed">
                {practice.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}